module.exports = __webpack_public_path__ + "static/img/map2.c0239e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map2.jpg
// module id = sYR9
// module chunks = 1